// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AlertEventKind } from "./Shared.AlertEventKind.gen";

export interface IAlertEvent {
	id: string | undefined;

	alertId: string | undefined;

	kind: AlertEventKind;

	occurredAtUtc: string | undefined;

	actorUserId: string | undefined;

	payloadJson: string | undefined;

	$type?: string | undefined;
}
export class AlertEvent {
	constructor(data?: IAlertEvent) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.occurredAtUtc) { this.occurredAtUtc = new Date(data.occurredAtUtc); }
	}

	id: string | undefined;

	alertId: string | undefined;

	kind: AlertEventKind = 0;

	occurredAtUtc: Date | undefined = new Date();

	actorUserId: string | undefined;

	payloadJson: string | undefined;

	static $type: string = "CoreApi.Models.Alerts.AlertEvent, ";
	$type?: string | undefined = AlertEvent.$type;
}

